import {
  INCREASE_COUNT,
  DECREASE_COUNT,
  SET_SEUIL_UPDATE,
  GET_DATA,
  SET_COUNT,
} from "../actionType";

export const initialState = {
  count: 0,
  update: false,
  data: {},
};

export const seasons = (state = initialState, action: any) => {
  switch (action.type) {
    case INCREASE_COUNT: {
      return { ...state, count: state.count < 3 ? state.count + 1 : 3 };
    }
    case SET_COUNT: {
      return { ...state, count: action.payload };
    }
    case DECREASE_COUNT: {
      return { ...state, count: state.count - 1 };
    }
    case SET_SEUIL_UPDATE: {
      return { ...state, update: action.payload };
    }
    case GET_DATA: {
      return { ...state, data: action.payload };
    }
    default:
      return state;
  }
};
